import _typeof from "./typeof.js";
import toPrimitive from "./toPrimitive.js";
//#region \0@oxc-project+runtime@0.143.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
export { toPropertyKey as default };
